import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import WhySection from "../../components/WhySection/WhySection";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards";

export default function GreeceJurisdiction() {

    return (
        <main className='main'>
            <IntroSection
                title="Greece Jurisdiction"
                subtitle="Company Formation, Residency & Investment Opportunities"
                description="Greece has become a popular destination for residency by investment, tax optimization, and company formation. With its Golden Visa program, strategic EU location, and favorable non-dom tax regime, Greece offers both lifestyle and business advantages for international investors."
                badges={[
                    "EU Residency by Investment",
                    "Company Formation",
                    "Non-Dom Tax Incentives"
                ]}
                buttonText="Request a Greece Jurisdiction Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/jurisdictions/greece-jurisdiction.png')}
                imageAlt="Greece Company Formation & Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Greece?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Golden Visa Program",
                                        text: "Residency from €250,000 property investment."
                                    },
                                    {
                                        title: "EU Market Access",
                                        text: "Full European Union membership."
                                    },
                                    {
                                        title: "Tax Benefits",
                                        text: "Special non-dom tax regime (flat €100k tax for HNWIs moving tax residence)."
                                    },
                                    {
                                        title: "Lifestyle",
                                        text: "Mediterranean climate, rich culture, and high quality of life."
                                    },
                                    {
                                        title: "Strategic Location",
                                        text: "Gateway to Europe, Middle East, and North Africa."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Company Formation in Greece"
                        blocks={[
                            {
                                title: "Private Limited Company (IKE / EPE)",
                                items: [
                                    { text: "Common SME structure." }
                                ]
                            },
                            {
                                title: "Société Anonyme (AE)",
                                items: [
                                    { text: "For larger corporations." }
                                ]
                            },
                            {
                                title: "Branch of Foreign Company",
                                items: [
                                    { text: "Easy entry for international firms." }
                                ]
                            },
                            {
                                title: "Partnerships (OE / EE)",
                                items: [
                                    { text: "For small businesses." }
                                ]
                            },
                            {
                                title: "Key Features",
                                items: [
                                    { text: "Minimum capital requirements are low or nil for IKE." },
                                    { text: "Company formation time: 1–2 weeks." },
                                    { text: "Access to EU VAT number and banking." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency & Citizenship"
                        blocks={[
                            {
                                title: "Golden Visa (Residency by Investment)",
                                items: [
                                    { text: "Minimum Investment: €250,000 in real estate (one of the lowest thresholds in the EU)." },
                                    { text: "Validity: 5 years renewable, permanent residency possible." },
                                    { text: "Coverage: Main applicant + spouse + children + dependent parents." },
                                    { text: "Benefits: Free travel in Schengen Zone." }
                                ]
                            },
                            {
                                title: "Citizenship",
                                items: [
                                    { text: "After 7 years of continuous residency." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Tax Benefits & Non-Dom Regime'
                        services={[
                            {
                                title: "Flat Tax for HNWIs",
                                text: "€100,000 annual tax for HNWIs transferring tax residency to Greece (covers global income)."
                            },
                            {
                                title: "Inheritance & Gift Tax",
                                text: "Exemptions under certain conditions."
                            },
                            {
                                title: "Favorable Pensioner Tax",
                                text: "Flat 7% tax for retirees relocating to Greece."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Advantages of Greece Jurisdiction'
                        features={[
                            {
                                title: "EU Residency & Citizenship Path",
                                text: "Structured route to EU residency and eventual citizenship."
                            },
                            {
                                title: "Affordable Investment Threshold",
                                text: "Investment starting from €250,000."
                            },
                            {
                                title: "Non-Dom Tax Regime",
                                text: "Special tax regime for high-net-worth individuals."
                            },
                            {
                                title: "Access to EU Banking & Business",
                                text: "Full EU market integration."
                            },
                            {
                                title: "Lifestyle Benefits",
                                text: "Mediterranean culture, climate, and safety."
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to secure EU residency and invest in Greece?"
                        description="Offshore Advisory provides property investment guidance, Golden Visa applications, and company formation services."
                        buttonText="Book a Greece Consultation Today →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the minimum real estate investment for Greece Golden Visa?",
        answer: "€250,000."
    },
    {
        question: "Does Greece allow dual citizenship?",
        answer: "Yes."
    },
    {
        question: "How long does it take to get residency?",
        answer: "2–4 months from application."
    },
    {
        question: "Can I invest in commercial property?",
        answer: "Yes, both residential and commercial real estate qualify."
    },
    {
        question: "Is Greece good for tax planning?",
        answer: "Yes, especially for HNWIs under the non-dom €100k flat tax regime."
    }
];

